import { useEffect, useRef, useState } from "react";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import getXcolumnJson from "@/pages/comp/edu/lecture/common/list/xcolumn/list";
import strFunc from "@/lib/lyg/string";
import LoadingComponent from "@/pcomponents/common/content/loading";
import LectureDataFunc from "@/pcomponents/common/content/edu/lecture/func/data";
import WriteAreaComponent from "@/pages/comp/edu/lecture/common/write/write_area";

function WriteLectureSimpleArea(props: any) {
  let myProps = {
    row_data: {},
    is_update: false,
    callback_refresh: (inData: any) => { },
    close_text: "닫기",
    close_func: () => { },
    is_show_close_btn: true,
    ...props
  };
  
  const xColumnArr = getXcolumnJson();
  const [isUpdate, setIsUpdate] = useState(myProps.is_update);
  const [rowData, setRowData] = useState({
    ...LectureDataFunc.default_lecture_row_data,
    ...myProps.row_data
  });
  const [room_info_arr, set_room_info_arr] = useState<any>([]);
  const pageData = {
    "write_btn_text": "등록",
    "confirm_msg": "등록 하시겠습니까?",
  };
  const [teacher_arr, set_teacher_arr] = useState([]);
  if (isUpdate) {
    pageData["write_btn_text"] = "저장";
    pageData["confirm_msg"] = "저장 하시겠습니까?";
  }
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });
  useEffect(() => {
    getSelectRoomList();
    getSelectTeacherList();
  }, []);

  const getSelectRoomList = () => {
    let formJsonData = {
      "order_id": "a_name",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/room/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_room_info_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });

  };

  const getSelectTeacherList = () => {
    let formJsonData = {
      "s_grade": ["teacher", "master"],
      "order_id": "a_user_name",
      "s_is_login": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_teacher_arr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const goWrite = () => {
    if (rowData.a_name == "") {
      alert("수업명 입력이 필요합니다.");
      return false;
    }
    if (strFunc.is_empty(rowData.a_subject)) {
      alert("과목 입력이 필요합니다.");
      return false;
    }
    if (!confirm(pageData["confirm_msg"])) {
      return false;
    }

    let formJsonData: any = {
      "data_arr": [{ ...rowData }],
      "is_update": "",
    };

    if (isUpdate) {
      formJsonData["is_update"] = "1";
    } else {
      formJsonData["is_default_val"] = "1";
    }

    set_loading_data({
      is_display: true,
      text: "저장 중입니다.",
    });
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/lecture/write', formJsonData, get_axios_data())
      .then((response) => {
        set_loading_data({
          ...loading_data,
          is_display: false,
        });
        if (response.data["result"] === "true") {
          alert("저장 되었습니다.");
          myProps.callback_refresh({select_seq: response.data["data"][0]["a_seq"]});
          myProps.close_func();
        } else {
          alert(response.data["msg"]);
        }
      });

  };


  return (
    <div>
      <div>
        <WriteAreaComponent
          rowData={rowData}
          setRowData={setRowData}
          xColumnArr={xColumnArr}
          room_info_arr={room_info_arr}
          teacher_arr={teacher_arr}
        ></WriteAreaComponent>
      </div>
      <div className="text-center mt-1">
        <button className="btn btn-sky" 
          onClick={()=>{
            goWrite();
          }} >{pageData.write_btn_text}</button>
        {myProps.is_show_close_btn&&
          <button className="btn btn-dark ml-1" onClick={()=>{myProps.close_func();}}>{myProps.close_text}</button>
        }
      </div>
      {loading_data.is_display &&
        <LoadingComponent text={loading_data.text}></LoadingComponent>
      }
    </div>
  );
};
export default WriteLectureSimpleArea;